import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { MuiAccordionModule } from './accordion';
import { MuiAlertModule } from './alert';
import { MuiAvatarModule } from './avatar';
import { MuiBannerModule } from './banner';
import { MuiBellIconModule } from './bell-icon';
import { MuiBreadcrumbsModule } from './breadcrumbs';
import { MuiButtonModule } from './button';
import { MuiCardModule } from './card';
import { MuiCarouselModule } from './carousel';
import { MuiChipModule } from './chip';
import { MuiCirclePercentModule } from './circle-percent';
import { MUI_APP_CONFIG, MuiModuleConfig } from './config';
import { MuiContextMenuModule } from './context-menu';
import { MuiDropzoneModule } from './dropzone';
import { MuiErrorModule } from './error';
import { MuiFormsModule } from './forms';
import { MuiHeroAreaModule } from './hero-area';
import { MuiIconModule } from './icon';
import { MuiLabelValueModule } from './label-value';
import { MuiListModule } from './list';
import { MuiLoaderModule } from './loader';
import { configureModals, MuiModalModule, MuiModalService } from './modal';
import { MuiNumberBadgeModule } from './number-badge';
import { MuiPaginationModule } from './pagination';
import { MuiPopoverModule } from './popover';
import { MuiProgressBarModule } from './progress-bar';
import { MuiSkeletonModule } from './skeleton';
import { MuiSpacingModule } from './spacing';
import { MuiStickyModule } from './sticky';
import { MuiTableModule } from './table';
import { MuiTabsModule } from './tabs';
import { MuiToastModule } from './toast';
import { MuiUtilityModule } from './utility';
import { MuiWizardModule } from './wizard';


const muiSubModules = [
  MuiAccordionModule,
  MuiAlertModule,
  MuiAvatarModule,
  MuiBannerModule,
  MuiBellIconModule,
  MuiBreadcrumbsModule,
  MuiButtonModule,
  MuiCardModule,
  MuiCarouselModule,
  MuiChipModule,
  MuiCirclePercentModule,
  MuiContextMenuModule,
  MuiDropzoneModule,
  MuiErrorModule,
  MuiFormsModule,
  MuiHeroAreaModule,
  MuiIconModule,
  MuiLabelValueModule,
  MuiListModule,
  MuiLoaderModule,
  MuiModalModule,
  MuiNumberBadgeModule,
  MuiPaginationModule,
  MuiPopoverModule,
  MuiProgressBarModule,
  MuiSkeletonModule,
  MuiSpacingModule,
  MuiTableModule,
  MuiTabsModule,
  MuiToastModule,
  MuiUtilityModule,
  MuiWizardModule,

  MuiStickyModule
];

const muiModuleBaseConfig: MuiModuleConfig = {
  homeUrl: '/',
  useHrefForHomeLinks: false
};

@NgModule({
  imports: muiSubModules,
  exports: muiSubModules
})
export class MuiModule {
  /**
   * Load and initialize the MuiModule with the given configuration. This method should only be called once in the root module of
   * an application. For child and lazy loaded modules, use the forChild() method instead or import the MuiModule directly if you
   * don't need new instances of the providers.
   *
   * @param {MuiModuleConfig} config
   * @returns {ModuleWithProviders<MuiModule>}
   */
  static forRoot(config?: MuiModuleConfig): ModuleWithProviders<MuiModule> {
    // Override base config with user defined settings
    config = Object.assign({}, muiModuleBaseConfig, config);

    return {
      ngModule: MuiModule,
      providers: [
        { provide: MUI_APP_CONFIG, useValue: config },
        { provide: APP_INITIALIZER, useFactory: configureModals, deps: [NgbModalConfig], multi: true }
      ]
    };
  }

  /**
   * Returns the MuiModule with a new instance of the MuiModalService, which is required to use the correct injection scope for
   * opened modals. If this method is not used, the MuiModalService from the root injector will be used.
   *
   * @returns {ModuleWithProviders<MuiModule>}
   */
  static forChild(): ModuleWithProviders<MuiModule> {
    return {
      ngModule: MuiModule,
      providers: [
        MuiModalService
      ]
    };
  }
}
